<template>
  <div :id="id" class="row align-items-center">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />
    <LmTextInput
      v-if="validateSuperUser"
      :id="`name-${id}`"
      class="col-12 col-md-4"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />
    <LmSelect
      :id="`css-${id}`"
      class="col-12 col-md-4"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-3',text: '25%'},
          {value: 'col-6', text: '50%'},
          {value: 'col-9', text: '75%'},
          {value: 'col-12', text: '100%'}
        ]
      }"
      :label="$t('desktop_view_width')"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <LmTextInput
      :id="`help-${id}`"
      class="col-12 col-md-8"
      v-model="component.componentProps.help"
      @input="$emit('input', component)"
      :label="$t('helper_text_setter')"
      :placeholder="$t('helper_text_setter')"
      :help="$t('helper_text_setter_help')"
    />
    <LmTextInput
      v-if="component.componentProps.btnPreview"
      class="col-12 col-md-6"
      v-model="component.componentProps.pathToPreview"
      @input="$emit('input', component)"
      :label="$t('preview_path')"
      :placeholder="$t('preview_path')"
      :help="$t('preview_path')"
      isApiPath
    />
    <LmCheckbox
      class="col-12 col-md-4"
      v-model="component.componentProps.btnPreview"
      :labelSingle="$t('preview_button')"
      @input="$emit('input', component)"
    />
    <LmCodeInput
      class="col-12"
      v-model="component.componentProps.defaultValue"
      :label="$t('default_value')"
      @input="$emit('input', component)"
    />
    <div class="col-12">
      <h5>{{ $t('variables') }}</h5>
      <div
        v-for="(option, index) in component.componentProps.variables"
        :key="index"
        class="row align-items-center"
      >
        <LmTextInput
          :id="`text-${id}-${index}`"
          class="col-12 col-md-5"
          v-model="component.componentProps.variables[index].text"
          :label="$t('description')"
          :placeholder="$t('description')"
        />
        <LmTextInput
          :id="`value-${id}-${index}`"
          class="col-12 col-md-3"
          v-model="component.componentProps.variables[index].value"
          @input="$emit('input', component)"
          :label="$t('variable')"
          :placeholder="$t('variable')"
        />
        <LmSelect
          :id="`type-${id}-${index}`"
          class="col-12 col-md-3"
          v-model="component.componentProps.variables[index].type"
          @input="$emit('input', component)"
          :options="{
            disabledOption: $t('select_an_option'),
            content: [
              { value: 'String', text: $t('text') },
              { value: 'Variable', text: $t('variable') },
              { value: 'Array', text: $t('list') },
              { value: 'Boolean', text: $t('boolean') },
            ]
          }"
          :label="$t('type')"
          :placeholder="$t('type')"
        />
        <font-awesome-icon
          :id="`trash-icon-${index}`"
          class="clickable mt-3 col-12 col-md-1"
          icon="trash"
          @click="removeOption(index)"
          v-b-tooltip.hover.top="$t('delete')"
        />
      </div>
      <LmButton
        class="col-auto px-0"
        :id="`lm-button-${id}`"
        type="button"
        :value="$t('add_option')"
        @click="addOption"
      />
    </div>
    <hr class="w-100 mx-2">
    <div class="col-12">
      <h5>{{ $t('validations') }}</h5>
      <div class="row align-items-center">
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('required')"
          v-model="validations.required"
          @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :id="id"
      :leftValueToCompareOptions="leftValueToCompareOptions"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
      @input="$emit('input', component)"
      />
    <LmConditionalByEditModeBuilderUi
      :component="component"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCodeInput from '@/components/form/elements/LmCodeInput'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {}
  },
  components: {
    LmButton,
    LmCheckbox,
    LmSelect,
    LmCodeInput
  },
  methods: {
    addOption () {
      this.component.componentProps.variables.push({ text: '', value: '' })
    },
    removeOption (optionIndex) {
      this.component.componentProps.variables.splice(optionIndex, 1)
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
